import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { ProjectChatsSection } from '../ProjectDashboard/ProjectChatsSection';
export const ChatTab = /*#__PURE__*/ memo(function ChatTab({ projectId, userRole }) {
    return /*#__PURE__*/ _jsx(ProjectChatsSection, {
        projectId: projectId,
        userRole: userRole
    });
});
